<div class="street-light-planner-step2-manual">
  <p class="label question">{{ 'module.energyMap.streetlightPlanner.step2ManualInstructionText' | translate }}</p>
</div>
